import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { businessProfileApi } from "@/api/businessProfileApi";
import { api } from "@/utils/axiosInterceptor";

export const useBusinessProfile = (businessId?: string) => {
    const queryClient = useQueryClient();

    const {
      data: expiredDate,
      isLoading,
      isError
    } = useQuery({
      queryKey: ["expiredDate", businessId],
      queryFn: async () => {
        const response = await api.get("/expired-date")

        return response
      }
    })
  
    const updateBusinessProfileMutation = useMutation({
      mutationFn: ({ businessId, profileData }: { businessId: string; profileData: any }) =>
        businessProfileApi.updateBusinessProfile(businessId, profileData), 
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["businessProfile"] }); 
      },
      onError: (error: any) => {
        console.error("Error updating business profile:", error.response?.data || error);
      },
    });

    const uploadCompanyLogo = useMutation({
      mutationFn: (file: File) => {
        const formData = new FormData();
        formData.append("logo", file);

        return api.put(
          "/company-logo",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      },
    })
  
    return {
      expiredDate,
      isLoading,
      isError,
      updateBusinessProfile: updateBusinessProfileMutation.mutate,
      isUpdatingBusinessProfile: updateBusinessProfileMutation.isPending,
      uploadCompanyLogo: uploadCompanyLogo.mutateAsync,
    };
  };
  